import { projectManagementApi } from '@/includes/projectManagementApi';

const pmDecisionAnalyticsService = {
  async getProjectDecisionAnalytics(projectId, { weeks = 8 } = {}) {
    const response = await projectManagementApi.get(
      `/projects/${projectId}/analytics/decisions`,
      { params: { weeks } },
    );
    return response.data;
  },
};

export default pmDecisionAnalyticsService;
